import React from 'react';
import { Typography, Link, Breadcrumbs } from '@mui/material';

interface PathSegment {
    name: string;
    path: string;
}

interface PathBreadcrumbsProps {
    path: string | undefined; 
    onNavigate: (path: string) => void;
}

const PathBreadcrumbs: React.FC<PathBreadcrumbsProps> = (props) => {
    const { path, onNavigate } = props;

    if (!path) return null;

    // Split the path and create segments
    const segments: PathSegment[] = path.split('/').reduce((pathSegments: PathSegment[], part: string, index: number, pathParts: string[]) => {
        if (part) {
            pathSegments.push({
                name: part,
                path: pathParts.slice(0, index + 1).join('/')
            });
        }
        return pathSegments;
    }, []);

    if (segments.length === 0) return null;

    return (
        <Breadcrumbs>
            {segments.map((segment, index) => {
                const isLast = index === segments.length - 1;
                return isLast ? (
                    <Typography key={segment.path} color="text.primary">
                        {segment.name}
                    </Typography>
                ) : (
                    <Link
                        key={segment.path}
                        component="button"
                        variant="body1"
                        underline="hover"
                        color="primary"
                        onClick={() => onNavigate(segment.path)}
                    >
                        {segment.name}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default PathBreadcrumbs;
